import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './score-circle.module.scss';

const cx = classnames.bind(styles);

function ScoreCircle({ correct, total, variant }) {
  const topcss = cx({
    top: true,
    [`top-${variant}`]: variant,
  });
  const bottomcss = cx({
    bottom: true,
    [`bottom-${variant}`]: variant,
  });

  return (
    <div className={styles.score}>
      <div className={topcss}>
        <span>{correct}</span>
      </div>
      <div className={bottomcss}>{total}</div>
    </div>
  );
}

ScoreCircle.propTypes = {
  correct: PropTypes.number,
  total: PropTypes.number,
  variant: PropTypes.oneOf(['fail', 'pass', 'perfect']),
};

ScoreCircle.defaultProps = {
  variant: 'fail',
};

export default ScoreCircle;
